import { Fade } from 'react-awesome-reveal';
import { 
  FaGraduationCap, 
  FaUniversity, 
  FaCalendarAlt 
} from '../../common/Icons';
import './Education.css';

const Education = () => {
  return (
    <div className="education-container full-page-section section-padding" id="education">
      
      <Fade direction="up" triggerOnce={true}>
        <h2 className="education-title-h2">
          <span>// Education</span>
        </h2>
      </Fade>
      
      <Fade direction="up" triggerOnce={true} delay={100}>
        <p className="education-highlight-text">
          <b>A key point about my journey: I completed both my Computer Engineering Degree and Master's Degree while working full-time as a Software Developer, demonstrating strong organizational skills and a passion for continuous learning.</b>
        </p>
      </Fade>
      
      <Fade direction="up" triggerOnce={true} delay={100} cascade damping={0.1}>
        <div className="education-timeline">
          
          <div className="education-card">
            <div className='education-title'>
              <FaGraduationCap />
              <h3>Master's Degree in Cybersecurity & Privacy</h3>
            </div>
            <p className="education-institution">
              <FaUniversity /> Universitat Oberta de Catalunya
            </p>
            <p className="education-date">
              <FaCalendarAlt /> Completed in 2024 (Average Grade: 9+/10)
            </p>
            <p className="education-description">
              Final Master's Project: A Capture The Flag (CTF) in a simulated real-world environment across multiple Linux machines, utilizing a variety of pentesting, auditing, and analysis tools.
            </p>
          </div>

          <div className="education-card">
            <div className='education-title'>
              <FaGraduationCap />
              <h3>Computer Engineering (Ended)</h3>
            </div>
            <p className="education-institution">
              <FaUniversity /> Universitat Oberta de Catalunya
            </p>
            <p className="education-date">
              <FaCalendarAlt /> 2020 - 2024
            </p>
            <p className="education-description">
              Final Degree Project: Complete development and refactoring of the employee time-tracking application for MediaMarkt Iberia, implemented in production for +400 users.
            </p>
          </div>
          
          <div className="education-card">
            <div className='education-title'>
              <FaGraduationCap />
              <h3>Computer Engineering (Started)</h3>
            </div>
            <p className="education-institution">
              <FaUniversity /> EPSEVG - Universitat Politècnica de Catalunya
            </p>
            <p className="education-date">
              <FaCalendarAlt /> 2017 - 2020
            </p>
          </div>

        </div>
      </Fade>
    </div>
  );
};

export default Education;